import type { ProjectId } from '../schema';
import getProjectsInLocalStorage from './getProjectsInLocalStorage';

export default function getPanAndZoomFromLocalStorage(projectId: ProjectId) {
    try {
        const {
            pan: { x, y },
            zoom,
        } = getProjectsInLocalStorage()[projectId];

        if (typeof zoom === 'number' && typeof x === 'number' && typeof y === 'number') {
            return { pan: { x, y }, zoom };
        }
    } catch {}
    return null;
}
